import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { scrollToTop } from '../../helper/scrollToTop.js';
import { useFetchIllustrations } from '../../hooks/useFetchIllustrations.js';
import IllustrationData from './IllustrationData.jsx';

const Shop = () => {
  const PAGE_SIZE = 10;
  const [index, setIndex] = useState(0);
  const [visibleData, setVisibleData] = useState([]);
  const [illustrations, isLoading] = useFetchIllustrations();

  const [showButtonUp, setShowButtonUp] = useState(false);

  const numberOfItems = PAGE_SIZE * (index + 1);

  const handleVisibleButton = () => {
    const position = window.scrollY;
    if (position > 50) {
      return setShowButtonUp(true);
    } else if (position < 50) {
      return setShowButtonUp(false);
    }
  };

  const handleLoadMore = () => {
    document.startViewTransition(() => {
      setIndex((prev) => prev + 1);
    });
  }

  useEffect(() => {
    window.addEventListener('scroll', handleVisibleButton);
  }, []);

  const getNewArrayWithFixedIndex = () => {
    const newArray = [];

    for (let i = 0; i < illustrations.length; i++) {
      if (i < numberOfItems) {
        newArray.push(illustrations[i]);
      }
    }
    return newArray;

  }
  useEffect(() => {
    const arrayWithFixedNumberOfItem = getNewArrayWithFixedIndex();
    setVisibleData([...arrayWithFixedNumberOfItem]);
  }, [index, illustrations]);

  return (
    <>
      <div className="container mx-auto px-5">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
          <IllustrationData data={visibleData} isLoading={isLoading} />
        </div>
        <div
          className={`${visibleData.length === illustrations.length ? 'hidden' : 'block'
            } flex justify-center items-center mt-6`}
        >
          <button
            onClick={handleLoadMore}
            className="bg-[#FD87D1] font-nunito font-bold rounded-xl hover:text-white hover:bg-[#7BF2BC]  p-2 text-lg"
          >
            {' '}
            Load More
          </button>
        </div>
        <div className="flex justify-end items-end overflow mt-4">
          <button
            id="scrollToTopBtn"
            className={`${showButtonUp ? 'block' : 'hidden'
              } bg-[#FD87D1] rounded-xl hover:text-white hover:bg-[#7BF2BC]  p-3 text-lg`}
            onClick={() => scrollToTop()}
          >
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>
      </div>
    </>
  );
};

export default Shop;
